// removed by extract-text-webpack-plugin
module.exports = {"infoPage":"_1BnnV3UL1v259nUVfdbkqq","socialInfo":"_3RURLvcpbuQ9PNEfZIu8ci","fb":"_2bA3w36rwLCyzwzHeEJ-ac","changesHead":"_126YloRWsvM1YFZOlSuJSf","header":"SnOWbO1tuN96P1zVGFn8f","image":"_11BfJ7L4Zb9oH2FOXj_zkU","nightPragma":"_2eqtrzuMLVdR3J-jdT3LT"};


//////////////////
// WEBPACK FOOTER
// ./src/components/InfoPage/InfoPage.scss
// module id = 821
// module chunks = 0